import {searchRequirementsList} from '../../firebase/firestore/icr';

function linkedKey(linked) {
    return linked?.eeiNumber || linked?.id || '';
}

function pickSearchMatch(linked, items) {
    const num = linkedKey(linked);
    if (!Array.isArray(items) || !items.length) {
        return null;
    }
    return items.find((item) => item.number === num || item.id === linked.id) || items[0];
}

function fallbackItem(linked) {
    const number = linkedKey(linked);
    return {
        id: linked.id || number,
        number,
        type: 'EEI',
        question: linked.text || linked.title || linked.name || '',
        priority: linked.priority ?? null,
        authorUserId: linked.authorUserId ?? null,
        authorDisplayName: linked.authorDisplayName ?? linked.author ?? null,
        dataCoveragePct: linked.dataCoveragePct ?? null,
        analyticCoveragePct: linked.analyticCoveragePct ?? null,
        dueDate: linked.dueDate ?? null,
        status: linked.status ?? null,
    };
}

function mergeLinkedWithSearch(linked, search) {
    const base = fallbackItem(linked);
    if (!search) {
        return base;
    }
    return {
        ...search,
        id: linked.id || search.id,
        number: search.number || base.number,
        type: search.type || 'EEI',
        question: search.question || base.question,
    };
}

/**
 * Enrich minimal collection-task EEI links with search-page fields
 * (priority, author, coverage, due date).
 * @param {Array<{id?: string, eeiNumber?: string, text?: string}>} linkedEeis
 */
export async function enrichLinkedEeis(linkedEeis) {
    if (!Array.isArray(linkedEeis) || linkedEeis.length === 0) {
        return [];
    }

    const enriched = await Promise.all(
        linkedEeis.map(async (linked) => {
            const num = linkedKey(linked);
            if (!num) {
                return fallbackItem(linked);
            }
            try {
                const resp = await searchRequirementsList({
                    entityType: 'eei',
                    q: num,
                    size: 10,
                });
                const match = pickSearchMatch(linked, resp?.items);
                return mergeLinkedWithSearch(linked, match);
            } catch {
                return fallbackItem(linked);
            }
        }),
    );

    return enriched;
}
